import type { SVGProps } from 'react';

export const SvgIconCategory160 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.875 11.125V6.125L19.875 3.125V11.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.875 15.0375V12.125C20.875 11.8598 20.7696 11.6054 20.5821 11.4179C20.3946 11.2304 20.1402 11.125 19.875 11.125H13.875C13.6098 11.125 13.3554 11.2304 13.1679 11.4179C12.9804 11.6054 12.875 11.8598 12.875 12.125V15.0375"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 15.125H12.875C12.3918 15.125 12 15.52 12 16.0074V29.2426C12 29.73 12.3918 30.125 12.875 30.125H21C21.4832 30.125 21.875 29.73 21.875 29.2426V16.0074C21.875 15.52 21.4832 15.125 21 15.125Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
